import { render } from "./UMiLogo.vue?vue&type=template&id=a8af6834"
import script from "./UMiLogo.vue?vue&type=script&lang=js"
export * from "./UMiLogo.vue?vue&type=script&lang=js"

import "./UMiLogo.vue?vue&type=style&index=0&id=a8af6834&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__